// @ts-check
import React, { useState } from 'react';
import { PillTabs, PillTab } from 'preferral-ui/components/PillTabs';
import { VerticalBarChart } from './VerticalBarChart';

/** @typedef {{
  name: string,
  value: number
}} DataElem */

/** @typedef {{
  data: Record<string, any>[];
  labelKey: string;
  valueKey: string;
  labelName: string;
  valueName: string;
}} TableOrVerticalBarChartProps */

/** @type { React.FC<TableOrVerticalBarChartProps> } */
export const TableOrVerticalBarChart = (props) => {
  const { data, labelKey, valueKey, labelName, valueName } = props;
  const [activeTab, setActiveTab] = useState('CHART');

  return (
    <div>
      <div className="flex justify-center mb-4">
        <PillTabs activeTab={activeTab} onChange={setActiveTab}>
          <PillTab tab="CHART">Chart</PillTab>
          <PillTab tab="TABLE">Table</PillTab>
        </PillTabs>
      </div>

      {activeTab === 'CHART' ? (
        <VerticalBarChart data={data} labelKey={labelKey} valueKey={valueKey} />
      ) : (
        <table className="bulma__table" style={{ margin: '0px auto' }}>
          <thead>
            <tr>
              <th>{labelName}</th>
              <th>{valueName}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((datum) => (
              <tr key={datum[labelKey]}>
                <td>{datum[labelKey]}</td>
                <td>{datum[valueKey]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
